import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Form,
  Col,
  Modal,
  Popover,
  message,
  Row,
  Select,
  Input,
  Alert,
} from "antd";
import { userSignOut, userSignInSuccess } from "../../appRedux/actions/Auth";
import ProfileImage from "../../assets/images/default_profile.jpg";
import { withRouter } from "react-router-dom";
import Service from "../../service";
import PhoneInput from "react-phone-input-2";
import { isValidPhoneNumber } from "libphonenumber-js";
import { normalizePhoneDigits } from "../../util/phoneNumber";
import "react-phone-input-2/lib/style.css";
import {
  ExclamationCircleOutlined,
  UserOutlined,
  TeamOutlined,
  LockOutlined,
  LogoutOutlined,
  DownOutlined,
  CreditCardOutlined,
  BellOutlined,
} from '@ant-design/icons';
import "./UserMenu.css";


import { showAuthLoader, hideAuthLoader } from "../../appRedux/actions/Auth";
import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  TAB_SIZE,
} from "../../constants/ThemeSetting";

import {
  capitalizeFirstLetter,
  relationshipArry,
} from "../../components/EmpInfoManagement/constants";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

import Trophylsner from "../../assets/KarmaIcons/waffle.png";
import { getResource } from "../../util/getResourcePermission";
import config from "../../permission/config.json";
import { getRoles } from "../../util/getRoles";
import SubscriptionDetailsModal from "../../components/SubscriptionDetails/SubscriptionDetailsModal";

const formItemLayoutContact = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const popoverStyle = {
  position: "absolute",
  top: "50px",
  right: "0",
  width: "250px",
  background: "white",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  borderRadius: "8px",
  padding: "16px",
  border: "1px solid #ddd",
};

const profileContainerStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const gridContainerStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "10px",
  border: "1.427px solid #07385C",
  padding: "8px",
  background: "linear-gradient(180deg, #FFF 0%, #DAF0FF 100%)",
  borderRadius: " 14.265px",
};

const buttonStyle = {
  padding: "10px",
  borderRadius: "6px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  border: "none",
  cursor: "pointer",
  background: "transparent",
};

const buttonTextStyle = {
  fontSize: "12px",
  marginTop: "5px",
  color: "gray",
};
const handleImgError = (e) => {
  e.target.onerror = null; // prevent infinite loop
  e.target.src = ProfileImage;
};

const MenuRow = ({ icon, danger, onClick, children }) => (
  <li
    className={`um-menu-item${danger ? " um-menu-item-danger" : ""}`}
    role="menuitem"
    tabIndex={0}
    onClick={onClick}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick();
      }
    }}
  >
    <span className="um-menu-icon">{icon}</span>
    <span className="um-menu-label">{children}</span>
  </li>
);

const exceptThisSymbols = ["e", "E", "+", "-", "."];
const UserProfile = (props) => {
  const dispatch = useDispatch();
  const LogoAction = useSelector((state) => state.common);
  const companySlug = localStorage.getItem("companyDomain");

  const Logo = localStorage.getItem(`LogoURL_${companySlug}`);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [visible, setVisible] = useState(false);
  const [addeditform] = Form.useForm();
  const { authUser } = useSelector(({ auth }) => auth);
  const user_data = JSON.parse(localStorage.getItem("user_data"));
  const location = useLocation();
  const { width } = useSelector(({ settings }) => settings);
  const [sideBarlogo, setSideBarlogo] = useState();
  const [ssoToken, setssoToken] = useState(localStorage.getItem("ssoToken"));
  const [relationshipOptions, setRelationshipOptions] = useState([...relationshipArry]);
  const [searchValue, setSearchValue] = useState("");
  const [forceUpdate, setForceUpdate] = useState(0); // Add this line
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [isEducationModalOpen, setIsEducationModalOpen] = useState(false);
  const [isExperienceModalOpen, setIsExperienceModalOpen] = useState(false);
  const [passwordForm] = Form.useForm();

  const contact = () => {
    addeditform.resetFields();
    setRelationshipOptions([...relationshipArry]);
    setSearchValue("");
    setIsContactModalOpen(true);
  };

  useEffect(() => {
    setInterval(() => { }, 300000);
  }, []);

  const getAdminListLogo = async () => {
    try {
      const params = `/${authUser?._id}`;
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.adminSetting + params,
      });
      if (response.data?.data?.config?.adminSetting?.logo) {
        setSideBarlogo(response.data.data.config.adminSetting.logo);
      } else {
        if (LogoAction.logo) {
          setSideBarlogo(LogoAction.logo);
        } else if (Logo) {
          setSideBarlogo(Logo);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchContactDetails = async () => {
    try {
      const empId = authUser?._id;
      const reqBody = {
        employee_id: empId,
      };
      dispatch(showAuthLoader());
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.contactList,
        body: reqBody,
      });
      dispatch(hideAuthLoader());
    } catch (error) {
      console.log(error);
      dispatch(hideAuthLoader());
    }
  };

  const handleAddEdit = async (values) => {
    try {
      const empId = authUser?._id;

      const reqBody = {
        employee_id: empId,
        employee_contact: {
          ...values,
        },
      };

      dispatch(showAuthLoader());
      let data = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.addContact,
        body: reqBody,
      });

      fetchContactDetails();
      getUserDetailsByID();
      let isContactsAdded = user_data?.isContactsAdded;
      if (data.status == 400) {
        message.error(data.data.message);
      } else {
        if (!isContactsAdded) {
          setIsContactModalOpen(false); // Close the controlled modal
          addeditform.resetFields();
          setRelationshipOptions([...relationshipArry]);
          setSearchValue("");
        }
      }

      dispatch(hideAuthLoader());
    } catch (error) {
      console.log(error);
      dispatch(hideAuthLoader());
    }
  };

  const readNotification = async (notification_id, slug) => {
    try {
      if (props.location.pathname == slug) {
        window.location.href = slug;
      }
      setVisible(false);
      const reqBody = {
        notification_id: notification_id,
        user_id: authUser?._id,
      };
      //   dispatch(showAuthLoader());

      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.readNotification,
        body: reqBody,
      });
      if (response.data.status === 200) {
        // setdata(response?.data?.data);
        // setCountdata(response?.data.metaData.totalCount);
        // message.success(response.metaData.totalCount);
      }
      //   dispatch(hideAuthLoader());
    } catch (error) {
      // dispatch(hideAuthLoader());
      console.log(error);
    }
  };
  const getUserDetailsByID = async () => {
    try {
      dispatch(showAuthLoader());
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.empById + "/" + authUser?._id,
        body: {},
      });

      const userData = response.data.data;
      localStorage.setItem("user_data", JSON.stringify(userData));
      // ENG-23: this used to only write localStorage. Redux's `authUser`
      // (read by WelcomeBanner's greeting, and by any other component that
      // reads via useSelector instead of localStorage) is seeded from
      // localStorage only once, at store init — it never re-reads on its
      // own. Without this dispatch, Redux keeps serving the pre-edit name
      // until a full page reload re-hydrates the store, while
      // localStorage-reading code (e.g. EngagePanel's currentUser()) already
      // sees the fresh record — exactly the greeting/Wall-post name
      // mismatch reported in ENG-23.
      dispatch(userSignInSuccess(userData));
      dispatch(hideAuthLoader());
    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
    }
  };


  const changepassword = async (value) => {
    try {
      dispatch(showAuthLoader());
      const reqBody = {
        oldpassword: value?.current_password,
        newPassword: value?.confirm_password,
        emp_id: authUser?._id,
        isPasswordChanged: true,
      };
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.hrmschangepassword,
        body: reqBody,
      });
      if (response.data.status === 200) {
        message.success(response.data.message);
        setIsModalOpen(false);
      } else {
        message.error(response.data.message);
      }
      dispatch(hideAuthLoader());
    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
    }
  };

  const [form] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    form.resetFields();
    setIsModalOpen(false);
  };
  useEffect(() => {
    getAdminListLogo();
  }, [LogoAction.logo]);


  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 10 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14 },
    },
  };

  const [openPopover, setOpenPopover] = useState(false);
  const [isSubscriptionOpen, setIsSubscriptionOpen] = useState(false);

  useEffect(() => {
    const closeOnSettingsOpen = (e) => {
      if (e.detail === "settings") setOpenPopover(false);
    };
    window.addEventListener("topbar-popover-open", closeOnSettingsOpen);
    return () => window.removeEventListener("topbar-popover-open", closeOnSettingsOpen);
  }, []);

  // const { authUser } = useSelector(({ auth }) => auth);
  const first_name =
    authUser.first_name?.charAt(0).toUpperCase() + authUser.first_name.slice(1);
  const last_name =
    authUser.last_name?.charAt(0).toUpperCase() + authUser.last_name.slice(1);
  const userName = first_name + " " + last_name;

  const imageUrl = authUser.emp_img
    ? `${Service.Server_Base_URL.replace(/\/$/, '')}/uploads/emp_images/${authUser.emp_img}`
    : ProfileImage;
  const roleName = authUser?.role_id?.role_name || user_data?.role_id?.role_name;
  const subtitle = [roleName, authUser?.emp_code].filter(Boolean).join(" \u2022 ");

  const userMenuOptions = (
    <div className="um-card">
      <div className="um-card-header">
        <img
          src={imageUrl}
          onError={handleImgError}
          className="um-card-avatar"
          alt="User"
        />
        <div className="um-card-identity">
          <div className="um-card-name" title={userName}>{userName}</div>
          {subtitle && <div className="um-card-role">{subtitle}</div>}
          {authUser?.email && (
            <div className="um-card-email" title={authUser.email}>{authUser.email}</div>
          )}
        </div>
      </div>
      <div className="um-divider" />
      <ul className="um-menu gx-user-popover">
        {
          user_data?.role_id?.role_name === config.ROLES.SUPERADMIN ? (
            <MenuRow icon={<LogoutOutlined />} danger onClick={() => dispatch(userSignOut())}>Logout</MenuRow>
          ) : (
            user_data?.role_id?.role_name === config.ROLES.ADMIN ?
              (
                <>
                  <MenuRow
                    icon={<UserOutlined />}
                    onClick={() => {
                      setOpenPopover(false);
                      props.history.push(`/${companySlug}/my-profile`);
                    }}
                  >
                    Edit Profile
                  </MenuRow>
                  <MenuRow
                    icon={<TeamOutlined />}
                    onClick={() => {
                      setOpenPopover(false);
                      props.history.push(`/${companySlug}/employee-overview`)
                    }}
                  >
                    Employee Overview
                  </MenuRow>
                  {/* Settings and Company Settings moved to Header Settings Dropdown */}
                  <MenuRow icon={<CreditCardOutlined />} onClick={() => { setIsSubscriptionOpen(true); setOpenPopover(false); }}>Subscription Details</MenuRow>
                  <MenuRow icon={<BellOutlined />} onClick={() => { setOpenPopover(false); props.history.push(`/${companySlug}/notification-settings`); }}>Email Preferences</MenuRow>
                  <MenuRow icon={<LockOutlined />} onClick={() => { showModal(); setOpenPopover(false) }}>Change Password</MenuRow>
                  <li className="um-divider" role="separator" />
                  <MenuRow icon={<LogoutOutlined />} danger onClick={() => dispatch(userSignOut())}>Logout</MenuRow>
                </>
              )
              :
              (
                authUser?.emp_code ? (
                  <>
                    <MenuRow
                      icon={<UserOutlined />}
                      onClick={() => {
                        setOpenPopover(false);
                        props.history.push(`/${companySlug}/my-profile`);
                      }}
                    >
                      Edit Profile
                    </MenuRow>
                    <MenuRow
                      icon={<TeamOutlined />}
                      onClick={() => {
                        setOpenPopover(false);
                        props.history.push(`/${companySlug}/employee-overview`)
                      }}
                    >
                      Employee Overview
                    </MenuRow>
                    <MenuRow icon={<BellOutlined />} onClick={() => { setOpenPopover(false); props.history.push(`/${companySlug}/notification-settings`); }}>Email Preferences</MenuRow>
                    <MenuRow icon={<LockOutlined />} onClick={() => { showModal(); setOpenPopover(false); }}>Change Password</MenuRow>
                    <li className="um-divider" role="separator" />
                    <MenuRow icon={<LogoutOutlined />} danger onClick={() => dispatch(userSignOut())}>Logout</MenuRow>
                  </>
                ) :
                  !authUser?.emp_code && (
                    <>
                      <MenuRow
                        icon={<UserOutlined />}
                        onClick={() => { props.history.push(`/${companySlug}/admin-edit`); setOpenPopover(false); }}
                      >
                        Edit Profile
                      </MenuRow>
                      <li className="um-divider" role="separator" />
                      <MenuRow icon={<LogoutOutlined />} danger onClick={() => dispatch(userSignOut())}>Logout</MenuRow>
                    </>
                  )
              )
          )}
      </ul>
    </div>
  );

  const changepasswordForCommon = async (value) => {
    try {
      dispatch(showAuthLoader());
      const reqBody = {
        oldpassword: value.old_password,
        newPassword: value.new_password,
        emp_id: authUser?._id,
        isPasswordChanged: true,
      };
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.hrmschangepassword,
        body: reqBody,
      });
      if (response.data.status == 200) {
        message.success(response.data.message);
        setIsPasswordModalOpen(false);
        passwordForm.resetFields();

        // Reflect isPasswordChanged: true in Redux + the cached snapshot right
        // away. Without this, the very next route change re-runs the
        // force-password-change effect against the stale isPasswordChanged:
        // false still sitting in authUser (App/index.js's getUserInfo() hasn't
        // refetched yet), and the modal flashes back open right after closing.
        const updatedAuthUser = { ...authUser, isPasswordChanged: true };
        dispatch(userSignInSuccess(updatedAuthUser));
        localStorage.setItem("user_data", JSON.stringify(updatedAuthUser));
      } else {
        message.error(response.data.message);
      }
      dispatch(hideAuthLoader());
    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
    }
  };

  const modalFormItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  };

  const success = () => {
    setIsPasswordModalOpen(true);
  };
  
  const Education = () => {
    setIsEducationModalOpen(true);
  };

  const Experience = () => {
    setIsExperienceModalOpen(true);
  };


  let navStyle = useSelector(({ settings }) => settings.navStyle);
  if (width < TAB_SIZE && navStyle === NAV_STYLE_FIXED) {
    navStyle = NAV_STYLE_DRAWER;
  }

  // Contacts/Education/Experience first-login prompts stay disabled (see the
  // git history for the original combined effect) - only the password-change
  // prompt is live, and only when the company has opted into it via
  // Settings → Security → "Force Password Change for New Employees".
  //
  // Re-checked on every route change (via routerPathname below) rather than
  // just once on login: this is meant to be a forced gate, not a one-time
  // nag, so dismissing it with Cancel and browsing elsewhere must bring it
  // right back until the password actually gets changed.
  //
  // routerPathname comes from connected-react-router's Redux state, NOT
  // react-router's useLocation() - UserProfile lives in the persistent
  // Topbar/Sidebar shell that never remounts across routes, and in that
  // position useLocation() does not reliably re-render this component on
  // navigation (every other useLocation() call in the codebase sits in a
  // component that itself remounts per-route, so it never had to prove
  // otherwise). Redux's state.router.location is guaranteed to update on
  // every navigation, which is the whole reason connected-react-router
  // exists here.
  const routerPathname = useSelector((state) => state.router?.location?.pathname);
  useEffect(() => {
    if (!authUser?._id) return;

    const isAdmin = getRoles(['Admin']) === true;
    if (isAdmin) return;

    const forcePasswordChangeEnabled = !!authUser?.companyId?.forcePasswordChangeForNewEmployees;
    if (forcePasswordChangeEnabled && authUser.isPasswordChanged === false) {
      setIsPasswordModalOpen(true);
    }
  }, [
    authUser?._id,
    authUser?.isPasswordChanged,
    authUser?.companyId?.forcePasswordChangeForNewEmployees,
    routerPathname,
  ]);
  return (
    <div className="gx-flex-row gx-align-items-center gx-avatar-row">
      {getResource(config.RESOURCES.WAFFLE, ["read"]) && (
        <button
          type="button"
          className="um-karma-chip"
          onClick={() => {
            props.history.push("/Waffle");
          }}
        >
          <img src={Trophylsner} alt="" />
          <span className="um-karma-count">
            {authUser?.total_remaining_karma
              ? authUser?.total_remaining_karma
              : 0}{" "}
            Waffle
          </span>
        </button>
      )}

      <Popover
        overlayClassName="user-menu-popover"
        placement="bottomRight"
        content={userMenuOptions}
        trigger="click"
        onOpenChange={(newVisible) => {
          setOpenPopover(newVisible);
          // Tell the settings menu to close - both open from the topbar and overlap.
          if (newVisible) window.dispatchEvent(new CustomEvent("topbar-popover-open", { detail: "profile" }));
        }}
        open={openPopover}
      >
        <button
          type="button"
          className={`um-pill${openPopover ? " um-pill-open" : ""}`}
          aria-haspopup="menu"
          aria-expanded={openPopover}
        >
          <img
            src={imageUrl}
            onError={handleImgError}
            className="um-pill-avatar"
            alt="User"
          />
          <span className="um-pill-name">{userName}</span>
          <DownOutlined className="um-pill-chevron" />
        </button>
      </Popover>

      <SubscriptionDetailsModal open={isSubscriptionOpen} onClose={() => setIsSubscriptionOpen(false)} />

      <Modal
        footer={[
          <Button
            key="back"
            className="ant-delete"
            onClick={handleCancel}
          >
            Cancel
          </Button>,
          <Button type="primary" htmlType="submit" onClick={() => form.submit()}>
            Change Password
          </Button>
        ]}
        title="Change Password"
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Alert
          type="info"
          showIcon
          message="This will also update your password on Payroll."
          style={{ marginBottom: 16 }}
        />
        <Form
          form={form}
          layout="vertical"
          onFinish={(values) => {
            changepassword(values);
          }}

        >
          <Form.Item
            label="Current Password"
            name="current_password"
            className="search-row"
            rules={[
              {
                required: true,
                message: "Please enter Current Password!",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            label="New Password"
            name="new_password"
            className="search-row"
            rules={[
              {
                required: true,
                message: "Please enter New Password!",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            label="Confirm Password"
            name="confirm_password"
            className="search-row"
            rules={[
              {
                required: true,
                message: "Please enter Confirm Password!",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("new_password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    "The confirm passwords that you entered do not match!"
                  );
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
      
        </Form>
      </Modal>
      {/* Add Contact Modal - Controlled */}
      <Modal
        title={
          <span>
            <ExclamationCircleOutlined style={{ color: '#faad14', marginRight: 8 }} />
            Add Contact Detail
          </span>
        }
        open={isContactModalOpen}
        closable={true}
        maskClosable={true}
        className="add-contact-modal"
        onCancel={() => {
          setIsContactModalOpen(false);
          addeditform.resetFields();
          setRelationshipOptions([...relationshipArry]);
          setSearchValue("");
          if (
            authUser.isEducationDetailsAdded === false &&
            location.pathname !== `/${companySlug}/my-profile`
          ) {
            setIsEducationModalOpen(true);
          } else if (
            authUser.experience != 0 &&
            (authUser.isExperienceDetailsAdded === false &&
              location.pathname !== `/${companySlug}/my-profile`)
          ) {
            setIsExperienceModalOpen(true);
          }
        }}
        footer={[
          <Button
            key="submit"
            type="primary"
            id="addbutton"
            onClick={() => {
              return addeditform.validateFields()
                .then(values => {
                  handleAddEdit(values);
                  setIsContactModalOpen(false);
                })
                .catch(err => {
                  return Promise.reject(err);
                });
            }}
          >
            Save Contact
          </Button>
        ]}
      >
        <div className="basic_info_form_wrapper">
          <Form
            {...modalFormItemLayout}
            layout="vertical"
            form={addeditform}
            onFinish={handleAddEdit}
          >
            <Row>
              <Col md={24} sm={24}>
                <Form.Item
                  name="name"
                  label="Name"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Name",
                    },
                    {
                      max: 30,
                      message: "Name should be less than 30 characters",
                    },
                  ]}
                  normalize={capitalizeFirstLetter}
                >
                  <Input placeholder='Contact Name' />
                </Form.Item>
              </Col>
              <Col md={24} sm={24}>
                <Form.Item
                  name="mobile"
                  label="Contact No."
                  rules={[
                    {
                      required: true
                    },
                    {
                      validator: (_, value) => {
                        if (!value) {
                          return Promise.resolve();
                        }

                        const digits = normalizePhoneDigits(value);
                        const phoneWithPlus = `+${digits}`;

                        if (!isValidPhoneNumber(phoneWithPlus)) {
                          return Promise.reject(
                            new Error("Please enter valid Contact Number")
                          );
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <PhoneInput
                    international
                    country={"in"}
                    placeholder="Enter phone number"
                    countryCodeEditable={false}
                  />
                </Form.Item>
              </Col>
              <Col md={24} sm={24}>
                <Form.Item
                  name="relationship"
                  label="Relation"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Your Relation",
                    },
                    {
                      max: 30,
                      message: "Relationship should be less than 30 characters",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Type or select relationship"
                    filterOption={false}
                    onSearch={(value) => {
                      setSearchValue(value);

                      if (!value || value.trim() === "") {
                        setRelationshipOptions([...relationshipArry]);
                        return;
                      }

                      const trimmedValue = value.trim();
                      const filtered = relationshipArry.filter((opt) =>
                        opt.toLowerCase().includes(trimmedValue.toLowerCase())
                      );

                      const exists = relationshipArry.some(
                        (opt) => opt.toLowerCase() === trimmedValue.toLowerCase()
                      );

                      if (!exists) {
                        setRelationshipOptions([...filtered, capitalizeFirstLetter(trimmedValue)]);
                      } else {
                        setRelationshipOptions(filtered);
                      }
                    }}
                    onChange={(value) => {
                      if (value) {
                        const normalizedValue = value.trim();
                        if (normalizedValue) {
                          const exists = relationshipArry.some(
                            (opt) => opt.toLowerCase() === normalizedValue.toLowerCase()
                          );
                          if (!exists) {
                            relationshipArry.push(capitalizeFirstLetter(normalizedValue));
                          }
                        }
                      }
                      setSearchValue("");
                      setRelationshipOptions([...relationshipArry]);
                    }}
                    onBlur={() => {
                      if (searchValue && searchValue.trim()) {
                        const normalizedValue = searchValue.trim();
                        const exists = relationshipArry.some(
                          (opt) => opt.toLowerCase() === normalizedValue.toLowerCase()
                        );

                        if (!exists) {
                          const capitalizedValue = capitalizeFirstLetter(normalizedValue);
                          relationshipArry.push(capitalizedValue);
                          addeditform.setFieldsValue({ relationship: capitalizedValue });
                        } else {
                          const matchingOption = relationshipArry.find(
                            (opt) => opt.toLowerCase() === normalizedValue.toLowerCase()
                          );
                          if (matchingOption) {
                            addeditform.setFieldsValue({ relationship: matchingOption });
                          }
                        }
                      }
                      setSearchValue("");
                      setRelationshipOptions([...relationshipArry]);
                    }}
                    allowClear
                  >
                    {relationshipOptions.map((i, index) => (
                      <Select.Option key={`${i}-${index}`} value={i}>
                        {i}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>

      {/* Password Modal - Controlled */}
      <Modal
        title={
          <span>
            <ExclamationCircleOutlined style={{ color: '#faad14', marginRight: 8 }} />
            Change Password
          </span>
        }
        open={isPasswordModalOpen}
        closable={false}
        maskClosable={false}
        keyboard={false}
        className="add-contact-modal"
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              return passwordForm.validateFields()
                .then(values => {
                  changepasswordForCommon(values);
                })
                .catch(err => {
                  return Promise.reject(err);
                });
            }}
          >
            Change Password
          </Button>
        ]}
      >
        <div className="basic_info_form_wrapper">
          <Alert
            type="info"
            showIcon
            message="This will also update your password on Payroll."
            style={{ marginBottom: 16 }}
          />
          <Form

            layout="vertical"
            form={passwordForm}
            onFinish={changepasswordForCommon}
          >
            <Row>
              <Col md={24} sm={24}>
                <Form.Item
                  label="Current Password"
                  name="old_password"
                  className="search-row"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Current Password!",
                    },
                  ]}
                >
                  <Input.Password placeholder="Enter current password" />
                </Form.Item>
              </Col>
              <Col md={24} sm={24}>
                <Form.Item
                  label="New Password"
                  name="new_password"
                  className="search-row"
                  rules={[
                    {
                      required: true,
                      message: "Please enter New Password!",
                    },
                  ]}
                >
                  <Input.Password placeholder="Enter new password" />
                </Form.Item>
              </Col>
              <Col md={24} sm={24}>
                <Form.Item
                  label="Confirm Password"
                  name="confirm_password"
                  className="search-row"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Confirm Password!",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("new_password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          "The confirm passwords that you entered do not match!"
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password placeholder="Confirm new password" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>

      {/* Education Modal - Controlled */}
      <Modal
        title={
          <span>
            <ExclamationCircleOutlined style={{ color: '#faad14', marginRight: 8 }} />
            Add Education Details
          </span>
        }
        open={isEducationModalOpen}
        closable={true}
        maskClosable={true}
        className="add-contact-modal"
        onCancel={() => {
          setIsEducationModalOpen(false);
          // Trigger next modal check
          if (
            authUser.experience != 0 &&
            (authUser.isExperienceDetailsAdded === false &&
              location.pathname !== `/${companySlug}/my-profile`)
          ) {
            setIsExperienceModalOpen(true);
          }
        }}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              setIsEducationModalOpen(false);
              props.history.push(`/${companySlug}/my-profile`);
            }}
          >
            Click Here
          </Button>
        ]}
      >
        <div className="basic_info_form_wrapper">
          <p>Please Fill Your Pending Education Details</p>
        </div>
      </Modal>

      {/* Experience Modal - Controlled */}
      <Modal
        title={
          <span>
            <ExclamationCircleOutlined style={{ color: '#faad14', marginRight: 8 }} />
            Add Experience Details
          </span>
        }
        open={isExperienceModalOpen}
        closable={true}
        maskClosable={true}
        className="add-contact-modal"
        onCancel={() => {
          setIsExperienceModalOpen(false);
        }}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              setIsExperienceModalOpen(false);
              props.history.push(`/${companySlug}/my-profile`);
            }}
          >
            Click Here
          </Button>
        ]}
      >
        <div className="basic_info_form_wrapper">
          <p>Please Fill Your Pending Experience Details</p>
        </div>
      </Modal>

    </div>
  );
};

export default withRouter(UserProfile);
